import Axios from 'axios';
import debugModule from 'debug';

const debug = debugModule('axios');

const axios = Axios.create({
  // baseURL: API_URL,
  // withCredentials: true,
});

axios.interceptors.request.use(config => {
  const {url, method, data} = config;
  debug(`Axios Req => ${method}: ${url}`);
  if (data instanceof FormData) {
    const params = [...data.entries()].reduce((acc, cur) => {
      const [name, value] = cur;
      if (!/Files$/.test(name))
        return ({...acc, [name]: value});
      if (!value || !Array.isArray(value) || 0 === value.length)
        return acc;
      const [file] = value;
      return ({...acc, [name]: file.originalname});
    }, {});
    debug(JSON.stringify(params, null, 2));
  } else if (data) {
    debug(JSON.stringify(data, null, 2));
  }
  return config;
}, error => {
  return Promise.reject(error);
});

axios.interceptors.response.use(response => {
  const {status, data, config} = response;
  const {url, method} = config;
  debug(`Axios Res(${status}) => ${method}: ${url}`);
  if (data) debug(JSON.stringify(data, null, 2));
  return response;
}, error => {
  return Promise.reject(error);
});

export default {
  install: (app, options) => {
    app.provide('axios', axios);
  }
};
